import React, { useContext } from 'react';
import { IconArrow } from 'components/svg';
import Link from 'next/link';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import {
  TRACKING_ACTION,
  TRACKING_INTERACTION,
} from 'contexts/AnalyticsContext/Constants';

/**
 * Renders menu items and call the dropdown component
 *
 * @param {func} goBack used to pass the event to the parent, and run the reverse animation.
 * @param {object} menu Object with the values of each menu item.
 * @param {func} onClick used to pass the active state and index of the selected item.
 * @param {object} show Object with the active value and index of the selected item.
 * @param {bool} showFavorites Boolean to show the favorites menu item from LaunchDarkly toggle at commons.
 * @param {bool} showWatchlist Boolean to show the watchlist menu item from LaunchDarkly toggle at commons.
 */

const UserItems = ({
  goBack,
  menu,
  onClick,
  show,
  showFavorites,
  showWatchlist,
}) => {
  const {
    utagFavoritesWatchlistClicked,
    categorizeFavoritesAndWatchlistUserEvent,
  } = useContext(AnalyticsContext);
  const { locale } = useContext(CruiseSearchContext);
  const {
    FAVORITES_AND_WATCHLIST: {
      CLICK_FAVORITE_NAV,
      CLICK_NAV_FAVORITES,
      CLICK_NAV_WATCHLIST,
    } = {},
  } = TRACKING_INTERACTION;
  const showFavoritesAndWatchlist = showFavorites && showWatchlist;

  const showFavoritesAndWatchlistClick = () => {
    onClick({ active: true, index: 0 });
    const interaction = {
      event: TRACKING_ACTION.NAV_CLICKS,
      interaction: CLICK_FAVORITE_NAV,
      extra: {
        country: locale?.country,
        language: locale?.language,
      },
    };
    utagFavoritesWatchlistClicked(interaction);
  };

  const sendEventFavoritesOrWatchList = (label, callRedirect) => {
    const eventToSend = categorizeFavoritesAndWatchlistUserEvent(label, [
      CLICK_NAV_FAVORITES,
      CLICK_NAV_WATCHLIST,
    ]);
    const interaction = {
      event: TRACKING_ACTION.NAV_CLICKS,
      interaction: eventToSend,
      extra: {
        country: locale?.country,
        language: locale?.language,
      },
    };
    utagFavoritesWatchlistClicked(interaction, callRedirect);
  };

  if (showFavoritesAndWatchlist) {
    return (
      <li>
        <a href="#" onClick={showFavoritesAndWatchlistClick}>
          {menu?.label}
          <IconArrow />
        </a>
        {show.active && show.index === 0 && (
          <Dropdown
            show={show.active}
            submenu={menu?.children}
            goBack={goBack}
            onClickEvent={sendEventFavoritesOrWatchList}
          />
        )}
      </li>
    );
  }
  if (showFavorites) {
    return (
      <Link href={menu.children.at(0)?.path}>{menu.children.at(0)?.label}</Link>
    );
  }
  if (showWatchlist) {
    return (
      <Link href={menu.children.at(1)?.path}>{menu.children.at(1)?.label}</Link>
    );
  }
};

UserItems.propTypes = {
  goBack: PropTypes.func,
  menu: PropTypes.shape({
    label: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        path: PropTypes.string,
      }),
    ),
  }),
  onClick: PropTypes.func,
  show: PropTypes.object,
  showFavorites: PropTypes.bool,
  showWatchlist: PropTypes.bool,
};

export default UserItems;
